module.exports = __webpack_public_path__ + "02_glasses_red.6b181406.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer4/02_glasses_red.png
// module id = EVzk
// module chunks = 0